export default __webpack_public_path__ + "static/media/hbs-blk-3.a62922b6.png";